import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react";

import { type EmojiTypes } from "commonComponents/btWrappers/editor/core/extensions/custom/emoji/EmojiMappings";

export interface IEmojiAttributes {
    "data-emojitext": string;
    "data-emojitype": EmojiTypes;
}

export const EditorEmoji = ({ node }: NodeViewProps) => {
    const attributes = node.attrs as IEmojiAttributes;
    return (
        <NodeViewWrapper as="span" className="editor-emoji">
            {attributes["data-emojitext"]}
        </NodeViewWrapper>
    );
};
